import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Workout from './pages/Workout';
import Schedule from './pages/Schedule';
import Pricing from './pages/Pricing';
import Book from './pages/Book';
import { About, Trainers, Press } from './pages/About';
import Results from './pages/Results';
import { HiitDallas, Neighborhood, UptownHub } from './pages/Locations';
import { FAQPage, FirstClass, Beginners } from './pages/FAQ';
import { BlogList, BlogPost } from './pages/Blog';
import Shop from './pages/Shop';
import Contact from './pages/Contact';
import Hyrox from './pages/Hyrox';
import Buy from './pages/Buy';
import { PaymentSuccess, PaymentCancel } from './pages/PaymentResult';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <section className="section-pad min-h-[60vh] flex items-center">
      <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center" data-testid="not-found-page">
        <p className="mono-label mb-4">404 · Page Not Found</p>
        <h1 className="h-display text-white">This page skipped class.</h1>
        <p className="text-muted-pf mt-5 text-[17px]">The page you're looking for doesn't exist or has moved. The pit, however, is right where you left it.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-9">
          <Link to="/" className="btn-primary" data-testid="notfound-home-link">Back to Home</Link>
          <Link to="/hiit-workout/schedule" className="btn-ghost">Live Schedule</Link>
          <Link to="/book" className="btn-ghost">Book a Class</Link>
        </div>
      </div>
    </section>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-workout" element={<Workout />} />
          <Route path="/hiit-workout/schedule" element={<Schedule />} />
          <Route path="/hiit-workout/first-class" element={<FirstClass />} />
          <Route path="/hiit-workout/beginners" element={<Beginners />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/book" element={<Book />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/trainers" element={<Trainers />} />
          <Route path="/about/press" element={<Press />} />
          <Route path="/results" element={<Results />} />
          <Route path="/hiit-classes-dallas" element={<HiitDallas />} />
          <Route path="/hyrox-classes-dallas" element={<Hyrox />} />
          <Route path="/hiit-classes-dallas/:slug" element={<Neighborhood />} />
          <Route path="/locations/uptown-dallas" element={<UptownHub />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
